export const NONE = { id: 'none', label: 'Nessuna metodica' };
export const EPIDURAL = { id: 'epidural', label: 'Analgesia epidurale' };
export const OTHER = { id: 'other', label: 'Altra metodica' };
export const NON_PHARMACOLOGICAL = {
  id: 'non_pharmacological',
  label: 'Metodica non farmacologica',
};
